import {
    onActivated,
    onBeforeMount,
    onBeforeUnmount,
    onBeforeUpdate,
    onDeactivated,
    onErrorCaptured,
    onMounted,
    onRenderTracked,
    onRenderTriggered,
    onServerPrefetch,
    onUnmounted,
    onUpdated
} from 'vue';

type TypeLife = 'onMounted'
    | 'onUpdated'
    | 'onUnmounted'
    | 'onBeforeMount'
    | 'onBeforeUpdate'
    | 'onBeforeUnmount'
    | 'onErrorCaptured'
    | 'onRenderTracked'
    | 'onRenderTriggered'
    | 'onActivated'
    | 'onDeactivated'
    | 'onServerPrefetch'
    | 'all';

export function useLifeLogger(payload: {
    name: string;
    typeLife?: TypeLife[];
    visible: boolean;
    // ts-ignore
    /* eslint-disable */
    data?: any
}) {
    const defaultTypeLife: TypeLife[] = ['onMounted', 'onUpdated', 'onUnmounted'];
    const typeLife = payload.typeLife ?? defaultTypeLife;

    const debug = process.env.NODE_ENV === 'development' ? payload.visible : false;
    if (!debug) {
        return;
    }

    const Style = {
        base: [
            'color: #000',
            'background-color: #444',
            'padding: 2px 4px',
            'border-radius: 2px'
        ],
        onBeforeMount: ['background-color: blue'],
        onMounted: ['background-color: green'],
        onBeforeUpdate: ['background-color: orange'],
        onUpdated: ['background-color: yellow'],
        onBeforeUnmount: ['background-color: purple'],
        onUnmounted: ['background-color: red'],
        onErrorCaptured: ['background-color: darkred'],
        onRenderTracked: ['background-color: cyan'],
        onRenderTriggered: ['background-color: magenta'],
        onActivated: ['background-color: lime'],
        onDeactivated: ['background-color: brown'],
        onServerPrefetch: ['background-color: navy']
    };

    const log = (text: string, extra: unknown[] = [], hookStyle: string[]) => {
        const style = Style.base.join(';') + ';' + hookStyle.join(';') + ';';
         
        if (extra.length) console.log(`%c${text}`, style, ...extra);
        else console.log(`%c${text}`, style);
    };

    const shouldLog = (hook: TypeLife) => {
        return typeLife.includes(hook) || typeLife.includes('all');
    };

    onBeforeMount(() => {
        if (shouldLog('onBeforeMount'))
            log(`${payload.name}: onBeforeMount`, payload.data ? [payload.data] : [], Style.onBeforeMount);
    });

    onMounted(() => {
        if (shouldLog('onMounted'))
            log(`${payload.name}: onMounted`, payload.data ? [payload.data] : [], Style.onMounted);
    });

    onBeforeUpdate(() => {
        if (shouldLog('onBeforeUpdate'))
            log(`${payload.name}: onBeforeUpdate`, payload.data ? [payload.data] : [], Style.onBeforeUpdate);
    });

    onUpdated(() => {
        if (shouldLog('onUpdated'))
            log(`${payload.name}: onUpdated`, payload.data ? [payload.data] : [], Style.onUpdated);
    });

    onBeforeUnmount(() => {
        if (shouldLog('onBeforeUnmount'))
            log(`${payload.name}: onBeforeUnmount`, payload.data ? [payload.data] : [], Style.onBeforeUnmount);
    });

    onUnmounted(() => {
        if (shouldLog('onUnmounted'))
            log(`${payload.name}: onUnmounted`, payload.data ? [payload.data] : [], Style.onUnmounted);
    });

    onErrorCaptured((err, instance, info) => {
        if (shouldLog('onErrorCaptured'))
            log(`${payload.name}: onErrorCaptured`, [err, instance, info, payload.data].filter(Boolean), Style.onErrorCaptured);
        return false; // чтобы ошибка не распространялась дальше
    });

    onRenderTracked(e => {
        if (shouldLog('onRenderTracked'))
            log(`${payload.name}: onRenderTracked`, [e, payload.data].filter(Boolean), Style.onRenderTracked);
    });

    onRenderTriggered(e => {
        if (shouldLog('onRenderTriggered'))
            log(`${payload.name}: onRenderTriggered`, [e, payload.data].filter(Boolean), Style.onRenderTriggered);
    });

    onActivated(() => {
        if (shouldLog('onActivated'))
            log(`${payload.name}: onActivated`, payload.data ? [payload.data] : [], Style.onActivated);
    });

    onDeactivated(() => {
        if (shouldLog('onDeactivated'))
            log(`${payload.name}: onDeactivated`, payload.data ? [payload.data] : [], Style.onDeactivated);
    });

    onServerPrefetch(async () => {
        if (shouldLog('onServerPrefetch'))
            log(`${payload.name}: onServerPrefetch`, payload.data ? [payload.data] : [], Style.onServerPrefetch);
    });
}
/*
Documentation
https://vuejs.org/api/composition-api-lifecycle.html
*/
